import React, { Component } from 'react';
import './../../custom.css';
import './../checkout_prem';
import delivery from './../../../statics/premCheck/delivery.png'
import fail from './../../../statics/premCheck/delivery.png'

class messagePrem extends Component {
    render(){
        return (
            <div className="message">
                <div className="msgPrem">
                <div>
                    {this.props.icon=="delivery"?
                        <img src={delivery}></img>
                    :
                        <div>
                        {
                        this.props.icon?
                            <img src={this.props.icon}></img>
                        :
                            "-"
                        }
                        </div>
                    }
                </div>
                {this.props.head?<h3> {this.props.head}</h3>: null}
                {this.props.body? <p className="c">{this.props.body}</p>: null}
                </div>         
            </div>
        );
    }
}

export default messagePrem;
